module.exports = __webpack_public_path__ + "static/media/installer-icon.f8055c26.svg";